'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { SUPPORTED_LOCALES } from '@/lib/locales';

/**
 * Keeps <html lang=""> in sync with the current path's locale prefix.
 *
 * The root layout hardcodes `lang="en"` to preserve static generation.
 * Locale-prefixed routes (e.g. `/es/...`) flip the attribute on the client
 * via this tiny effect. Screen readers pick up the change on navigation;
 * search engines rely on the `alternates.languages` metadata in each page's
 * `export const metadata`.
 */
export function LocaleLangSync() {
  const pathname = usePathname();

  useEffect(() => {
    const first = pathname.split('/').filter(Boolean)[0];
    const lang =
      first && (SUPPORTED_LOCALES as readonly string[]).includes(first)
        ? first
        : 'en';
    if (document.documentElement.lang !== lang) {
      document.documentElement.lang = lang;
    }
  }, [pathname]);

  return null;
}
